import { atom } from 'recoil';
import {
    Measurement,
    MeasurementDraft,
    MeasurementKind,
} from '~/domain/measurement/measurement';
import { annotationListState } from '~/state/atoms/annotationListAtoms';

/** Recoil state for the measurement tool; the record model lives in the domain. */

/** The committed measurements, one atom each, oldest first. */
export const measurementListState =
    annotationListState<Measurement>('measurement');

/** The current in-progress placement, or null when idle. */
export const measurementDraftState = atom<MeasurementDraft | null>({
    key: 'measurementDraftState',
    default: null,
});

/** Which kind of measurement the next placement creates. */
export const measurementModeState = atom<MeasurementKind>({
    key: 'measurementModeState',
    default: 'distance',
});

/**
 * Id of the measurement currently emphasized in the overlay, or null. Set
 * while hovering its row in the panel so the user can locate it on the image.
 */
export const highlightedMeasurementState = atom<string | null>({
    key: 'highlightedMeasurementState',
    default: null,
});
